import { render } from "./dispatchDetails.vue?vue&type=template&id=3328c132&scoped=true"
import script from "./dispatchDetails.vue?vue&type=script&lang=js"
export * from "./dispatchDetails.vue?vue&type=script&lang=js"

import "./dispatchDetails.vue?vue&type=style&index=0&id=3328c132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3328c132"]])

export default __exports__